import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { RxCross1 } from "react-icons/rx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { HttpService } from "../../service/HttpService";
import { useAuth } from "../../context/AuthProvider";
import SelectInput from "../SelectInput/SelectInput";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";

function AddEditNutrients({ open, setOpen, id = "", editData = "", fetchNutrients ,mode}) {
  const [units, setUnits] = useState([]);
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);

  const {
    name,
    unit,
    is_active
  } = editData || {};

  const validationSchema = Yup.object({
    name: Yup.string()
      .trim()
      .required("Nutrients Name is required"),
    unit: Yup.string()
      .trim()
      .required("Unit is required"),
    is_active: Yup.string().required("Status is required"),

  });

  const formik = useFormik({
    initialValues: {
    name: name || "",
    unit: unit || "",
    is_active: is_active === true ? "active" : "inactive",
    },
    validationSchema,
    enableReinitialize: true,
    validateOnChange: true,  
    onSubmit: async (values) => {
      try {
        const payload = {
          name: values.name.trim(),
          unit: Number(values.unit),
          is_active: values.is_active === "active" ? true : false,
        };

        if (!id || id === "") {
          const response = await httpService.post("nutrient/add-nutrient", payload);
          if (response) {
            toast.success("Nutrient Added Successfully", {
              position: "top-right",
            });
            formik.resetForm();
            setOpen(false);
            if (fetchNutrients) fetchNutrients();
          }
        } else {
          const response = await httpService.put(`nutrient/edit-nutrient/${id}`, payload);
          if (response) {
            toast.success("Nutrient Updated Successfully", {
              position: "top-right",
            });
            formik.resetForm();
            setOpen(false);
            if (fetchNutrients) fetchNutrients();
          }
        }
      } catch (error) {
        console.error("Error saving nutrient:", error);
        toast.error(
          error?.response?.data?.error || error?.response?.data?.message || "Failed to save nutrient",
          {
            position: "top-right",
          }
        );
      }
    },
  });

  const fetchUnits = () => {
    httpService
      .get("inventory/units")
      .then((response) => {
        setUnits(response.data); 
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  
  useEffect(() => {
    fetchUnits();
  }, [open]);

  useEffect(() => {
    if (open && editData && id) {
      formik.setValues({
        name: name || "",
        unit: unit || "",
        is_active: is_active === true ? "active" : "inactive",
      });
    } else if (open && !id) {
      formik.resetForm();
    }
  }, [open, id, editData]);

  return (
    <Modal
      className="department-modal"
      open={open}
      onClose={() => {
        formik.resetForm();
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal_block">
          <div className="modal_header">
            <div className="modal_title_wrapper">
              <h2 className="modal_title">
                {id ? "Edit Nutrients" : "Add Nutrients"}
              </h2>
            </div>
            <div className="cancel-btn-wrap">
              <RxCross1
                onClick={() => {
                  formik.resetForm();
                  setOpen(false);
                }}
              />
            </div>
          </div>
          <div className="modal_content">
            <div className="row">
              <div className="col-md-12">
                <div className="form_field_wrapper">
                  <label>
                    Nutrients Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <TextField
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Name"
                    variant="outlined"
                    fullWidth
                  />
                  {formik.touched.name && formik.errors.name && (
                    <span style={{ color: "red" }}>{formik.errors.name}</span>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="form_field_wrapper">
                 <SelectInput
                  name="unit"
                  label="Unit"
                  required={true}
                  value={formik.values.unit || ""}
                  options={units}
                  multiple={false}
                  onChange={(event) => {
                    formik.setFieldValue("unit", event.target.value);
                  }}
                  onBlur={formik.handleBlur}
                  error={formik.touched.unit && formik.errors.unit}
                                  displayEmpty
                />
                </div>
              </div>
              {id && <div>
                <div className="col-md-3">
                  <div className="form_field_wrapper mb-0">
                    <label>
                      Status
                    </label>
                  </div>
                </div>

                <div className="col-md-9">
                  <FormControl fullWidth>
                    <RadioGroup
                      row
                      name="is_active"
                      value={formik.values.is_active}
                      onChange={(e) => formik.setFieldValue("is_active", e.target.value)}
                      style={{
                        justifyContent: "flex-start",
                        gap: "16px",
                        flexWrap: "nowrap",
                      }}
                    >
                      <FormControlLabel
                        value="active"
                        control={<Radio size="small" color="success" />}
                        label="Active"
                        style={{ margin: 0, fontSize: "12px" }}
                      />

                      <FormControlLabel
                        value="inactive"
                        control={<Radio size="small" color="error" />}
                        label="Inactive"
                        style={{ margin: 0, fontSize: "12px" }}
                      />
                    </RadioGroup>

                    {formik.touched.is_active && formik.errors.is_active && (
                      <span style={{ color: "red" }}>{formik.errors.is_active}</span>
                    )}
                  </FormControl>
                </div>
              </div>}
            </div>
          </div>
          <div className="modal_footer">
            <button
              type="button"
              onClick={() => {
                formik.resetForm();
                setOpen(false);
              }}
              className="btn btn-border"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default AddEditNutrients;

